import { render, staticRenderFns } from "./ColorViewer.vue?vue&type=template&id=6935a79e&scoped=true&"
import script from "./ColorViewer.vue?vue&type=script&lang=js&"
export * from "./ColorViewer.vue?vue&type=script&lang=js&"
import style0 from "./ColorViewer.vue?vue&type=style&index=0&id=6935a79e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6935a79e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6935a79e')) {
      api.createRecord('6935a79e', component.options)
    } else {
      api.reload('6935a79e', component.options)
    }
    module.hot.accept("./ColorViewer.vue?vue&type=template&id=6935a79e&scoped=true&", function () {
      api.rerender('6935a79e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ItemLocations/ColorViewer.vue"
export default component.exports